import React from 'react';
import './mobile-clip-controls.css';

/**
 * Mobile-only: Set start / Set end / Reset (no custom seek — use YouTube/native controls).
 */
export default function MobileClipControls({
  markStep = 0,
  pendingStart = null,
  onSetStart,
  onSetEnd,
  onReset,
  disabled = false,
  feedback = null,
}) {
  return (
    <div className="mobile-clip-controls" aria-label="Clip marking">
      <div className="mobile-clip-controls__mark">
        <button
          type="button"
          className={`mobile-clip-controls__mark-btn mobile-clip-controls__mark-btn--start${markStep === 0 ? ' is-active' : ''}`}
          onClick={onSetStart}
          disabled={disabled || markStep !== 0}
        >
          Set start
        </button>
        <button
          type="button"
          className={`mobile-clip-controls__mark-btn mobile-clip-controls__mark-btn--end${markStep === 1 ? ' is-active' : ''}`}
          onClick={onSetEnd}
          disabled={disabled || markStep !== 1}
        >
          Set end
        </button>
        <button
          type="button"
          className="mobile-clip-controls__mark-btn mobile-clip-controls__mark-btn--reset"
          onClick={onReset}
          disabled={disabled || markStep === 0}
        >
          Reset
        </button>
      </div>

      <p className="mobile-clip-controls__status" aria-live="polite">
        {feedback || (
          markStep === 0
            ? 'Scrub with the video controls, then tap Set start.'
            : `Start: ${pendingStart || '—'} — scrub to end, tap Set end.`
        )}
      </p>
    </div>
  );
}
